import { useCanAccessPermission } from '@/shared/model/adminAccess';
import { Link } from '@/shared/ui/Link/Link';

interface ReviewReferenceProps {
    id?: string | null;
    name: string;
    section: 'orders' | 'executors' | 'clients';
    permission: string;
}

/** Показывает ссылку на участника или заказ отзыва при наличии доступа */
export const ReviewReference = ({ id, name, section, permission }: ReviewReferenceProps) => {
    const allowed = useCanAccessPermission(permission);

    return allowed && id
        ? <Link
            isBlank={false}
            text={name}
            url={`/${section}/${encodeURIComponent(id)}`}
        />
        : <span>{name}</span>;
};

